module.exports = __webpack_public_path__ + "b422e783c9b85cdee883ec8923ac12e3.woff2";